<template>
  <v-autocomplete
      :filled="!!filled"
      v-model="currentValue"
      :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-earth' : ''"
      :items="$locale.countriesItems"
      hide-no-data
      :label="$t('label')"
      :rules="rules"
      hide-details
      @keyup.enter.prevent="$emit('enter')"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'CountrySelect',
  props: ['value', 'filled'],
  data () {
    return {
      currentValue: this.value,
      rules: [
        v => !!v || this.$t('required'),
      ]
    }
  },
  watch: {
    currentValue () {
      this.$emit('update:value', this.currentValue)
    },
    value (value) {
      this.currentValue = value
    }
  },
}
</script>

<i18n>
{
	"en": {
		"label": "Country"
	},
	"es": {
		"label": "País"
	},
	"fr": {
		"label": "Pays"
	},
	"it": {
		"label": "Paese"
	},
	"pt": {
		"label": "País"
	},
	"pl": {
		"label": "Kraj"
	}
}
</i18n>